import { HttpService } from "@/core/services/http.service";
import {
  ApprovalDetailReq,
  ApprovalDetailResp,
  ApprovalSubmitReq,
} from "./approval-flow.interface";

export class ApprovalFlowService {
  static useDetailApi() {
    const api = (params: ApprovalDetailReq) =>
      HttpService.axios({
        method: "GET",
        url: `/examine_instance/detail`,
        params,
      });
    return HttpService.useRequest<ApprovalDetailResp>(api);
  }
  static useMultipleDetailApi() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/examine_instance/detailBatch",
        data,
      });
    function formatResult(data) {
      const result = {};
      data.records.forEach((ele) => {
        result[ele.bizId] = ele;
      });
      return result;
    }
    return HttpService.useRequest<{ records: ApprovalDetailResp[] }>(api, { formatResult });
  }

  //查找是否有对外付款单关联的租赁付款申请//根据付款合同id查询对应的对外付款单
  static existPaymentPage() {
    const api = (contractId:string)=>
    HttpService.axios({
      method:"GET",
      url:"/payment_order_external/paymentPage",
      params:{
        contractId:contractId,
        current:1,
        size:9999
      }
    })
    return HttpService.usePagination<any>(api)
  }

  //查找是否有关联的对外付款单
  static existRelationOrNot() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/lease/existRelationOrNot/${id}`,
      });
    return HttpService.useRequest<ApprovalDetailResp>(api);
  }

  static existAssuringRelationOrNot() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/margin_payment/existRelationOrNot/${id}`,
      });
    return HttpService.useRequest<ApprovalDetailResp>(api);
  }
  static existAssuringReturnRelationOrNot() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/margin_return/payment/${id}`,
      });
    return HttpService.useRequest<ApprovalDetailResp>(api);
  }
  static useSubmitApi() {
    const api = (data: ApprovalSubmitReq) =>
      HttpService.axios({
        method: "POST",
        url: `/examine_instance/submit`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useAgreeApi() {
    const api = (data: ApprovalSubmitReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/examine_instance/agree`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useRejectApi() {
    const api = (data: ApprovalSubmitReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/examine_instance/reject`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useCancelApi() {
    const api = (data: ApprovalSubmitReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/examine_instance/repeal`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useVoidApi() {
    const api = (data: ApprovalSubmitReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/examine_instance/cancel`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }
}
